import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { EmailComposer } from '@ionic-native/email-composer';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import moment from 'moment';
import { ToastAlertsProvider } from '../toast-alerts/toast-alerts';
import { AppState } from '../../config/state';

/*
  Generated class for the MailProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MailProvider {

  constructor(public http: HttpClient, private api: ApiProvider, private mail: EmailComposer, private toast: ToastAlertsProvider, private client: ClientDetailsProvider, private state: AppState) { }

  sendEmailForBrowser(contacts, from, subject, body) {
    if (contacts && contacts.length > 0) {
      let emails = [];

      contacts.forEach(contact => {
        emails.push(contact.email);
      });
      let email = {
        to: emails.join(','),
        subject: subject,
        body: body,
        isHtml: true,
        from: from
      }

      if (!from || from === '') {
        email.from = 'donotreply';
      }

      let response = this.sendNotification(email);
      console.log('notification resp', response);
      return response;
    }
  }

  sendNotification(params) {
    var fd = new FormData();
    fd.append('client_id', 'ioIovGsua94zG9iWPw5X');
    fd.append('client_secret', 'SlgiT3NH0thcnZBxdMu5');
    fd.append('grant_type', 'client_credentials');

    var emailFD = new FormData();
    for (var key in params) {
      emailFD.append(key, params[key]);
    }

    this.client.load().then((client) => {
      params.client = client.keyword;
      fetch(`http://api.communico.co/v3/token`, {
        method: 'POST',
        body: fd
      })
        .then(res => {
          let resp = res.json();
          resp.then((apiToken) => {
            let token = apiToken.access_token;
            params.token = token;
            //this.sendWithAuth(params).then((data)=>{
            //  console.log('swa', data);
            //});
            fetch(`http://api.communico.co/v2/${this.state.client.keyword}/notifications/email`, {
              method: 'POST',
              body: emailFD,
              headers: {
                'Authorization': 'Bearer ' + token
              }
            })
              .then(res => {
                return res.json();
              });

          });
        });
    });
  }

  async sendPresetNotification(params) {
    let type = params.type;
    let fields = params.fields;
    let notification: any = {};

    const query = `{
      getNotification(type:"${type}"){
        id, type, subject, body, html, tags
      }
    }`;

    let notificationData = await this.api.query(query);
    //$_POST['from'], $_POST['to'], $_POST['subject'], $_POST['body'], $_POST['html']
    let emailPack = {
      to: '',
      from: '',
      subject: '',
      body: '',
      html: ''
    };

    notification = notificationData.getNotification;

    try {
      notification.tags = JSON.parse(notification.tags);
    } catch (e) {
      notification.tags = {};
    }

    // console.log('f', params.fields);
    // console.log('n', notification);
    for (var key in fields) {
      if (notification.tags[key]) {
        var regExp = new RegExp(`{{${key}}}`, 'g');
        notification.body = notification.body.replace(regExp, fields[key]);
        if (notification.html !== null) {
          notification.html = notification.html.replace(regExp, fields[key]);
        } else {
          notification.html = notification.body;
        }
      }
    };

    // {{if}} checks
    notification.body = notification.body.replace(/{{if\s([\s\S]*?)=([\s\S]*?)}}([\s\S]*?){{endif}}/g, function (match, p1, p2, p3) {
      console.log('match', match);
      console.log('p1', p1);
      console.log('p2', p2);
      console.log('p3', p3);

      if (fields[p1] == p2) {
        return p3;
      } else {
        return "";
      }
    });

    notification.html = notification.html.replace(/{{if\s([\s\S]*?)=([\s\S]*?)}}([\s\S]*?){{endif}}/g, function (match, p1, p2, p3) {
      if (notification.tags[p1] == p2) {
        return p3;
      } else {
        return "";
      }
    });

    emailPack.body = notification.body;
    emailPack.html = notification.html;
    emailPack.from = 'donotreply';
    emailPack.to = fields.contact_email;
    emailPack.subject = notification.subject;

    //console.log('n', emailPack);

    var fd = new FormData();
    fd.append('client_id', 'ioIovGsua94zG9iWPw5X');
    fd.append('client_secret', 'SlgiT3NH0thcnZBxdMu5');
    fd.append('grant_type', 'client_credentials');

    var notificationFD = new FormData();
    for (var nkey in emailPack) {
      notificationFD.append(nkey, emailPack[nkey]);
    }

    this.client.load().then((client) => {
      params.client = client.keyword;
      fetch(`http://api.communico.co/v3/token`, {
        method: 'POST',
        body: fd
      })
        .then(res => {
          let resp = res.json();
          resp.then((apiToken) => {
            let token = apiToken.access_token;
            params.token = token;

            fetch(`http://api.communico.co/v2/${params.client}/notifications/email`, {
              method: 'POST',
              body: notificationFD,
              headers: {
                'Authorization': 'Bearer ' + token
              }
            })
              .then(res => {
                return res.json();
              });
          });
        });
    });
  }

  sendWithAuth(params) {
    //let params =
    let h = new HttpHeaders();
    let p = new HttpParams();
    h.set('Authorization', 'Bearer ' + params.token);

    for (let k in params) {
      p.set(k, params[k]);
    }

    return new Promise(resolve => {

      this.http.post(`http://api.communico.co/v2/${this.state.client.keyword}/notifications/email/`, params, { headers: h, params: p })
        ///this.httpClient.post(`https://seasons.libnet.info/brochure.php`, JSON.stringify(params))
        .subscribe(result => {
          return result;
        });
    });
  }

  sendMobileEmail(contacts, from, subject, body) {
    if (contacts && contacts.length > 0) {
      this.mail.isAvailable().then((available: boolean) => {
        this.mail.hasPermission().then((permission: boolean) => {
          let emails = [];

          contacts.forEach(contact => {
            emails.push(contact.email);
          });

          let email = {
            to: emails,
            subject: subject,
            body: body,
            isHtml: true
          }

          this.mail.open(email).then(() => {
            console.log('email', 'success');
            this.triggerToast('Email sent successfully.');
          },
            () => {
              console.log('email', 'failed');
              this.triggerToast('Email sent successfully*.');
            });
        }).catch((error: any) => {
          console.log('No email permissions!');
        });
      }, () => {
        console.log('email', 'failed-not available');
        this.triggerToast('Email sent successfully*.');
      });
    } else {
      console.log('email', 'failed');
      this.triggerToast('Email client unavailable.');
    }
  }

  triggerToast(msg) {
    this.toast.triggerToast(msg, '');
  }

  async sendBookReceipt(contact, info, platform) {
    let query;
    if (platform){
      query = `{
        sendNotification(type:"book_receipt", email:"${contact}", phone: "", vars:{first_name: "${info.first_name}", screen_type: "${info.screen_type}", book_list: "${info.book_list}", branch_name:"${info.branch_name}", barcode_end: "${info.barcode_end}", past_tense:"${info.past_tense}", total: "${info.total}", date: "${moment().format("MM/DD/YYYY hh:mm a")}"}) {
          type
          status
          message
        }
      }`;
    } else {
      query = `{
        sendNotification(type:"book_receipt", phone:"${contact}", email:"", vars:{first_name: "${info.first_name}", screen_type: "${info.screen_type}", branch_name:"${info.branch_name}", barcode_end: ${info.barcode_end}, total: "${info.total}"}) {
          type
          status
          message
        }
      }`;
    }

    let notificationData = await this.api.query(query);
    console.log(notificationData);
    return notificationData.sendNotification[0];
  }

  async sendReserveConfirmationEmail(params, content) {
    let query = `{
      sendNotification(type:"${params.template}", email:"${params.email}",phone: "${params.phone}", vars:{
        contact_first_name: "${content.contact_first_name}",
        contact_email: "${content.contact_email}",
        contact_last_name: "${content.contact_last_name}",
        contact_phone: "${content.contact_phone}",
        date: "${content.date}",
        display_name: "${content.display_name}",
        end_time: "${content.end_time}",
        group_name: "${content.group_name}",
        library_name: "${content.library_name}",
        location: "${content.location}",
        reference: "${content.reference}",
        room: "${content.room}",
        start_time: "${content.start_time}",
      }) {
        type
        status
        message
      }
    }`;
    console.log(query);

    let notificationData = await this.api.query(query);

    console.log(notificationData);

    return notificationData
  }

  async sendContactRequest(params, content) {
    let query = `{
      sendNotification(type:"${params.template}", email:"${params.email}",phone: "${params.phone}", vars:{
        branch: "${content.branch}",
        department: "${content.department}",
        issue: "${content.issue}",
        message: "${content.message}",
        images: "${content.images}"
      }) {
        type
        status
        message
      }
    }`;
    console.log(query);
    let notificationData = await this.api.query(query);

    console.log(notificationData);

    return notificationData
  }

  async sendGeneralEmail(params, content){
    let vars = JSON.stringify(content);
    let query = `{
      sendNotification(type:"${params.template}", email:"${params.email}",phone: "${params.phone}", vars:{${content}}) {
        type
        status
        message
      }
    }`;
    // console.log(query);

    let notificationData = await this.api.query(query);

    // console.log(notificationData);
    // let notificationData;
    return notificationData.sendNotification;
  }

  async sendItemInfoEmail(params, content){
    let query = `
    {
      sendNotification(type:"${params.template}", email:"${params.email}",phone: "${params.phone}", vars:{
        title: "${content.title}",
        author: "${content.author}",
        barcode: "${content.barcode}",
        isbn: "${content.isbn}",
        upc: "${content.upc}",
        available: "${content.available}",
        description: "${encodeURIComponent(content.description)}"
      }) {
        type
        status
        message
      }
    }`
    // console.log(query);
    let notificationData = await this.api.query(query);
    // console.log(notificationData);
    return notificationData
  }

  async sendEventInfoShareEmail(params, content){
    let query = `
    {
      sendNotification(type:"${params.template}", email:"${params.email}",phone: "${params.phone}", vars:{
        locationName: "${content.locationName}",
        eventTitle: "${content.eventTitle}",
        eventDate: "${content.eventDate}",
        eventStart: "${content.eventStart}",
        eventEnd: "${content.eventEnd}",
        eventLink: "${content.eventLink}",
        ifRegister: "${content.ifRegister}"
      }) {
        type
        status
        message
      }
    }`
    console.log(query);
    let notificationData = await this.api.query(query);
    console.log(notificationData);
    return notificationData
  }
}


// WEBPACK FOOTER //
// ./src/providers/mail/mail.ts